import React from "react";
import { createRoot } from "react-dom/client";
import { AdapterDateFns, LocalizationProvider, SaltFoundationProvider } from "@/design-system/salt";
import "./instrument";
import App from "./App.tsx";
import "./index.css";
/*
 * LAST, deliberately. This is our type ramp and it must be the final word on every
 * `--salt-text-*` value — `index.css` above still reads those tokens, and Salt's own theme
 * CSS arrives with the SaltFoundationProvider import on line 3. Move this line up and the
 * ramp silently reverts to the vendor's.
 */
import "@/design-system/tokens/typography.css";
import "@/design-system/tokens/color.css";
import "@/design-system/tokens/shape.css";

/**
 * Global chunk-load failure guard.
 *
 * When a stale cached index.html references JS chunks that no longer exist on
 * the server, Vercel's SPA fallback returns index.html (text/html) for the
 * missing .js files, causing "Failed to load module script" MIME errors at the
 * browser level — before React mounts and before the ErrorBoundary can catch
 * them.  This listener detects those failures and performs a cache-busting
 * reload (once per session) to fetch a fresh index.html with current chunk
 * hashes.
 */
window.addEventListener("error", (event) => {
  const msg = event.message || "";
  if (
    (msg.includes("Failed to load module script") ||
      msg.includes("Importing a module script failed") ||
      msg.includes("Failed to fetch dynamically imported module")) &&
    !sessionStorage.getItem("chunk_reload_attempted")
  ) {
    sessionStorage.setItem("chunk_reload_attempted", "1");
    const url = new URL(window.location.href);
    url.searchParams.set("_r", Date.now().toString());
    window.location.replace(url.toString());
  }
});

createRoot(document.getElementById("root")!).render(
  <SaltFoundationProvider>
    <LocalizationProvider DateAdapter={AdapterDateFns}>
      <App />
    </LocalizationProvider>
  </SaltFoundationProvider>,
);
